export const TEACH = 'TEACH'
export const STREAMING_LESSON_MEDIA = 'Streaming Lesson Media'
